module.exports = __webpack_public_path__ + "Flag-462.b20d4ef045336c7cfb07dd0823889c21.svg";